(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["section-jayone-video"] && !Shopify.designMode) return;
  try {
    
(function () {
  // Track is-playing class on the frame for any CSS hooks that depend on
  // playback state. Custom play-button overlay removed — native controls
  // handle the play/pause affordance entirely.
  var frames = document.querySelectorAll('[data-video-frame]');
  frames.forEach(function (frame) {
    var video = frame.querySelector('.jayone-video__player');
    if (!video) return;
    video.addEventListener('play',  function () { frame.classList.add('is-playing'); });
    video.addEventListener('ended', function () { frame.classList.remove('is-playing'); });
  });
})();

  } catch(e) { console.error(e); }
})();
})();
